import axios from 'axios'
import {CADASTRAR_AGENCIAS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function cadastrarRota(agencia) {
    const url = `${URL}/agencia/cadastrar`;
    return dispatch => axios.post(url, agencia, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_AGENCIAS,
            payload: response
        })
    );
}
